import { render, staticRenderFns } from "./administrative.vue?vue&type=template&id=67cbc267&scoped=true&"
import script from "./administrative.vue?vue&type=script&lang=js&"
export * from "./administrative.vue?vue&type=script&lang=js&"
import style0 from "./administrative.vue?vue&type=style&index=0&lang=less&"
import style1 from "./administrative.vue?vue&type=style&index=1&id=67cbc267&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cbc267",
  null
  
)

export default component.exports